export { SaleFacet } from './SaleFacet';
export type { SaleFacetProps } from './SaleFacet.types';
